import { createBrowserRouter } from "react-router-dom";
import { lazy, Suspense } from "react";
import type { ReactNode } from "react";
import RootLayout from "./layout/RootLayout";
import ScrollToTop from "./ScrollToTop";
import HomePage from "./pages/Home";

const NotFound = lazy(() => import("./pages/NotFound"));
const OutdoorSports = lazy(() => import("./pages/products/OutdoorSports"));
const PlaygroundPage = lazy(() => import("./pages/products/Playground"));
const EshopPage = lazy(() => import("./pages/e-shop"));
const News = lazy(() => import("./pages/recents/News"));
const GalleryPage = lazy(() => import("./pages/services/Gallery"));
const SafeCoatingsPage = lazy(() => import("./pages/Safecoatings"));
const EshopProduct = lazy(() => import("./components/eshop/EshopProduct"));

const withSuspense = (component: ReactNode) => (
  <Suspense fallback={<div className="min-h-[40vh]" />}>{component}</Suspense>
);

const router = createBrowserRouter([
  {
    path: "/",
    element: (
      <>
        <ScrollToTop />
        <RootLayout />
      </>
    ),
    children: [
      {
        path: "/",
        element: <HomePage />,
      },
      {
        path: "/zaidimu-aiksteles",
        element: withSuspense(<PlaygroundPage />),
      },
      { path: "/lauko-sportas", element: withSuspense(<OutdoorSports />) },
      {
        path: "/saugios-dangos",
        element: withSuspense(<SafeCoatingsPage />),
      },

      {
        path: "/galerija",
        element: withSuspense(<GalleryPage />),
      },

      {
        path: "/el-parduotuve",
        element: withSuspense(<EshopPage />),
      },
      {
        path: "/el-parduotuve/*",
        element: withSuspense(<EshopProduct />),
      },
      { path: "/naujausi", element: withSuspense(<News />) },

      {
        path: "*",
        element: withSuspense(<NotFound />),
      },
    ],
  },
]);

export default router;
